// Compact turn-duration formatter (fn-49.3, R4).
//
// Hand-formatted on purpose: `Intl.DurationFormat` sits at ~84%
// browser support (2026-06) — not enough for an embeddable package.
// Spirit of the console's `formatDelta` (console import forbidden by
// the boundary lint), tuned for end-user copy: no false precision,
// seconds floor, sub-second collapses to "<1s".
//
// The rendered strings live in the copy module (the i18n seam); this
// file owns only the math.
import { SUB_SECOND_DURATION, minutesDuration, secondsDuration } from '../copy/copy.js';
/**
 * Format a non-negative millisecond duration:
 *   - under 1s (and any non-finite/negative input, defensively) → "<1s"
 *   - under 60s → "12s"
 *   - 60s and over → "1m 23s" (exact minutes drop the seconds: "2m")
 */
export function formatDurationMs(ms) {
    if (!Number.isFinite(ms) || ms < 1_000)
        return SUB_SECOND_DURATION;
    const totalSeconds = Math.floor(ms / 1_000);
    if (totalSeconds < 60)
        return secondsDuration(totalSeconds);
    return minutesDuration(Math.floor(totalSeconds / 60), totalSeconds % 60);
}
//# sourceMappingURL=duration.js.map